import ModalShell from './ModalShell.jsx';
import ArchiveBrowser from '../../../../components/ArchiveBrowser.jsx';

// Wraps the shared ArchiveBrowser in a modal so the editor sees the exact
// same archive experience (article / edition toggle, filters, infinite
// scroll, inline expand) as the public /archive route. The browser auto-
// detects the modal's scroll container for infinite scroll.
export default function ArchiveModal({ onClose }) {
  return (
    <ModalShell
      title="Archive"
      eyebrow="Historical briefs"
      onClose={onClose}
      widthClass="max-w-6xl"
    >
      <ArchiveBrowser
        editionGridClass="grid grid-cols-1 md:grid-cols-2 gap-4"
      />
    </ModalShell>
  );
}
